import { ModalStatusAssinaturaComponent } from './../../components/modal-status-assinatura/modal-status-assinatura.component';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { PerfilService } from "../../services/perfil.service";
import { Empresa } from 'src/app/auth/models/empresa.model';
import { encryptStorage } from "../../../auth/utils/storage";

import { PedidoGarantia, CardGarantia, CardAgrupado } from "../../models/garantias.model";

import Swal from "sweetalert2";
import {
  showDefaultError,
  showError,
  showNotification,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";
import { safeAsign } from "src/app/shared/utils/functions/safe-asign.function";
import { ModalEditarDadosComponent } from "../../components/modal-editar-dados/modal-editar-dados.component";

enum TiposVisualizacao {
  INSTITUICAO_FINANCEIRA = 1,
  EMPRESA = 2
}
@Component({
  selector: "app-home-investidor",
  templateUrl: "./home-investidor.component.html",
  styleUrls: ["./home-investidor.component.scss"],
})
export class HomeInvestidorComponent implements OnInit, OnDestroy {
  modalRef: MDBModalRef;
  modalCloseEvent: any;

  visualizacaoSelecionada : TiposVisualizacao = TiposVisualizacao.INSTITUICAO_FINANCEIRA;
  garantias: PedidoGarantia[] = [];
  cardsPorIf: CardGarantia[] = [];
  cardsPorEmpresa: CardGarantia[] = [];
  cardsExibidos: CardGarantia[] = [];
  cardsExibidosFiltrados: CardGarantia[] = [];
  termoPesquisa: string = '';
  mostrarErro: boolean = false;
  mostrarPesquisaVazia: boolean = false;

  constructor(
    private perfilService: PerfilService,
    private router: Router,
    private modalService: MDBModalService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.listarSolicitacoes();

    this.modalCloseEvent = this.modalService.closed.subscribe(
      (modalWasClosed) => this.listarSolicitacoes()
    );
  }

  ngOnDestroy(): void {
    this.modalCloseEvent.unsubscribe();
  }

  listarSolicitacoes() {
    this.perfilService.consultaSolicitacoes().subscribe(
      (res) => {
        this.garantias = res?.garantias;
        this.mostrarErro = res?.garantias.length === 0;
      },
      (e) => {
        if (e.status == 500) {
          return showError("", e.statusText);
        }
        this.mostrarErro = true;
        return showDefaultError(e);
      },
      () =>{
        this.cardsPorIf = this.formatarPayloadPorIf(this.garantias);
        this.cardsPorEmpresa = this.formatarPayloadPorEmpresa(this.garantias);
        this.cardsExibidos = this.visualizacaoSelecionada === TiposVisualizacao.INSTITUICAO_FINANCEIRA ? this.cardsPorIf : this.cardsPorEmpresa;
      }
    );
  }

  formatarData(dataOriginal: string) : string{
    const data = new Date(dataOriginal);
    const dataFormatada = data.toLocaleDateString('pt-BR');
    return dataFormatada || dataOriginal;
  }

  formatarCNPJ(cnpj: string): string {
    if (!cnpj) return '';

    // Remove tudo que não é número
    const numerosCnpj = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    // Verifica se tem 14 dígitos
    if (numerosCnpj.length !== 14) {
      return cnpj; // Retorna o valor original se não tiver 14 dígitos
    }

    // Aplica a máscara: XX.XXX.XXX/XXXX-XX
    return numerosCnpj.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }

  formatarPayloadPorIf(garantias: PedidoGarantia[]) {
    const output: CardGarantia[] = [];

    garantias.forEach(garantia => {

      let cardExistente = output.find(card =>
        card.subtitulo.includes(this.formatarData(garantia.instituicaoLiquidada.dataLiquidacao)) &&
        card.titulo === garantia.instituicaoLiquidada.nome
      );

      const isDisponivel = garantia.status?.statusGarantia === 'SOLICITAR_GARANTIA';
      const naoDisponivel = garantia.status?.tipoProcesso?.descricao === "Pedido Indisponível";
      const novoAgrupado: CardAgrupado = {
        titulo: garantia?.investidor?.empresa?.nome || '',
        subtitulo: garantia?.investidor?.empresa?.cnpj ? `CNPJ: ${this.formatarCNPJ(garantia.investidor.empresa.cnpj)}` : '',
        textoBotao: this.textoBotaoExcecao(garantia),
        descricao: naoDisponivel ? garantia.status?.statusProcesso?.descricao : '',
        textoToast: isDisponivel ? 'Pedido disponível' : '',
        pedidoGarantia: garantia
      };

      if (!cardExistente) {
        const novoCard: CardGarantia = {
          titulo: garantia.instituicaoLiquidada.nome,
          subtitulo: `Liquidou em: ${this.formatarData(garantia.instituicaoLiquidada.dataLiquidacao)}`,
          textoToast: isDisponivel ? '1 pedido disponível' : '',
          agrupados: [novoAgrupado],
          expandido: false
        };

        output.push(novoCard);
      } else {
        cardExistente.agrupados = cardExistente.agrupados || [];
        cardExistente.agrupados.push(novoAgrupado);

        const pedidosDisponiveis = cardExistente.agrupados.filter(ag => ag.textoToast === 'Pedido disponível').length;
        cardExistente.textoToast = pedidosDisponiveis > 0 ?
          (pedidosDisponiveis > 1 ? `${pedidosDisponiveis} pedidos disponíveis` : '1 pedido disponível') : '';
      }
    });

    return output;
  }

  private textoBotaoExcecao(garantia: PedidoGarantia): string {
    const descricao = garantia.status?.tipoProcesso?.descricao || '';
    const statusGarantia = garantia.status?.statusGarantia;

    if (descricao === "Pedir garantia" && statusGarantia === "ACOMPANHAR_PEDIDO") {
      return "Acompanhar Garantia";
    }
    return descricao;
  }

  formatarPayloadPorEmpresa(garantias: PedidoGarantia[]) {
    const output: CardGarantia[] = [];
    const CNPJ_NULL_KEY = "SEM_EMPRESA";

    garantias.forEach(garantia => {
      let chaveCnpj: string;

      if (!garantia.investidor?.empresa?.cnpj) {
        chaveCnpj = CNPJ_NULL_KEY;
      } else {
        chaveCnpj = garantia.investidor.empresa.cnpj;
      }

      let cardExistente = output.find(card =>
        (chaveCnpj === CNPJ_NULL_KEY && card.titulo === "Empresas não identificadas") ||
        (chaveCnpj !== CNPJ_NULL_KEY && card.subtitulo === `CNPJ: ${this.formatarCNPJ(chaveCnpj)}`)
      );

      const isDisponivel = garantia.status?.statusGarantia === 'SOLICITAR_GARANTIA';
      const naoDisponivel = garantia.status?.tipoProcesso?.descricao === "Pedido Indisponível";
      const novoAgrupado: CardAgrupado = {
        titulo: garantia.instituicaoLiquidada?.nome || '',
        subtitulo: `Liquidou em: ${this.formatarData(garantia.instituicaoLiquidada.dataLiquidacao)}` || '',
        textoBotao: garantia.status?.tipoProcesso?.descricao || '',
        descricao: naoDisponivel ? garantia.status?.statusProcesso?.descricao : '',
        textoToast: isDisponivel ? 'Pedido disponível' : '',
        pedidoGarantia: garantia
      };

      if (!cardExistente) {
        let titulo: string;
        let subtitulo: string;

        if (chaveCnpj === CNPJ_NULL_KEY) {
          titulo = "Empresas não identificadas";
          subtitulo = "Garantias sem dados de empresa";
        } else {
          titulo = garantia.investidor?.empresa?.nome || 'Empresa não identificada';
          subtitulo = `CNPJ: ${this.formatarCNPJ(chaveCnpj)}`;
        }

        const novoCard: CardGarantia = {
          titulo: titulo,
          subtitulo: subtitulo,
          textoToast: isDisponivel ? '1 pedido disponível' : '',
          agrupados: [novoAgrupado],
          expandido: false
        };

        output.push(novoCard);
      } else {
        cardExistente.agrupados = cardExistente.agrupados || [];
        cardExistente.agrupados.push(novoAgrupado);

        const pedidosDisponiveis = cardExistente.agrupados.filter(ag => ag.textoToast === 'Pedido disponível').length;
        cardExistente.textoToast = pedidosDisponiveis > 0 ?
          (pedidosDisponiveis > 1 ? `${pedidosDisponiveis} pedidos disponíveis` : '1 pedido disponível') : '';
      }
    });

    return output;
  }

  exibirAlerta(idAlerta) {
    switch (idAlerta) {
      case 1: {
        //Alerta de Pagamento Efetivado
        showSucess(
          "Pagamento Efetivado", // Title
          "", //Text
          { html: "<p>O processo de pagamento de garantia referente a esta Instituição Financeira foi concluído.</p>" } //Title
        );
        break;
      }
      case 2: {
        //Alerta para pagamento Concluido
        showSucess(
          "Pagamento Concluído", // Title
          "", //Text
          { html: "<p>Pagamento Concluído. Consulte a área de histórico de pagamentos para mais detalhes !</p>" } //Title
        );
        break;
      }
      case 3: {
        return Swal.fire({
          title: "",
          text:
            "A Instituição Financeira em Regime Especial," + //Text
            "enviará ao FGC os dados de seus depositantes. Assim que recebermos os referidos dados, " +
            "será possível realizar a solicitação",
          iconHtml:
            '<img style="width: 60px" src="../../../../assets/icons/report.svg" alt="">',
        });
        break;
      }
      case 4: {
        //Alerta Termo
        showSucess(
          "", // Title
          "", //Text
          { html: "<p>O termo de cessão e sub-rogação de créditos foi gerado. As orientações de pagamento serão encaminhadas para o e-mail cadastrado.</p>" } //Title
        );
        break;
      }
      case 5: {
        //Alerta Anuência
        showSucess(
          "", // Title
          "", //Text
          { html: "<p>Sua solicitação foi concluída e está aguardando a anuência da corretora, assim que o FGC receber a informação da corretora, o termo de cessão será gerado e as orientações de pagamento serão enviadas para o e-mail cadastrado.</p>" } //Title
        );
        break;
      }
      case 6: {
        //Alerta Solicitacão Concluída
        showSucess(
          "Solicitação Concluída", // Title
          "", //Text
          { html: "<p>Sua solicitação foi concluída e está em processo de análise, estando em conformidade com as informações da Instituição Financeira, " +
            "o termo de cessão será gerado e as orientações de pagamento serão enviadas para o e-mail cadastrado.</p>" } //Title
        );
        break;
      }
      case 7: {
        //Alerta Praça
        showSucess(
          "",
          "",
          { html: "<p>Sua solicitação foi concluída, o termo de cessão e sub-rogação de créditos foi gerado e será encaminhado ao seu e-mail cadastrado com orientações sobre os próximos passos.</p>"}
        );
      }
    }
  }

  exibirMensagem(codigoStatus, tipoProcesso) {
    if (!safeAsign(codigoStatus) && !safeAsign(tipoProcesso)) {
      return showError(
        "Ocorreu um erro",
        "Houve um erro ao processar a sua solicitação, tente novamente mais tarde."
      );
    }

    let query = {
      stProcesso: codigoStatus,
      tpProcesso: tipoProcesso,
    };

    this.perfilService.acompanharProcessoSolicitacao(query).subscribe(
      (res) => showNotification("", res["data"]["mensagem"], undefined, { confirmButtonText: "Voltar à tela inicial" }),
      (e) => showDefaultError(e)
    );
  }

  solicitarGarantia(id, nomeEmpresa, cnpjEmpresa, nome, data, aguardandoDados, exibirRepresentantes) {
    if (aguardandoDados) {
      return this.exibirAlerta(3);
    }
    this.router.navigate(["/spg/solicita-garantia", id, nomeEmpresa, cnpjEmpresa, nome, data, exibirRepresentantes]);
  }

  realizarAcao(cardData : PedidoGarantia){
    const status = cardData.status?.statusGarantia;
    const statusProcesso = cardData.status?.statusProcesso?.codigo || 0;
    const tipoProcesso = cardData.status?.tipoProcesso?.codigo || 0;

    const isSolicitar = status === 'SOLICITAR_GARANTIA';
    const isCorrecao = status === 'CORRIGIR_DADOS_BANCARIOS';
    const isCorrigirInformacoes = status === 'CORRIGIR_DOCUMENTACAO_SOCIETARIA';
    const isAceitarTermo = status === 'ACEITAR_TERMO';
    const isPedidoAndamento = status === 'ACOMPANHAR_PEDIDO';

    if(isSolicitar || isCorrecao){
      this.solicitarGarantia(cardData.idPedido, cardData.investidor.empresa.nome, cardData.investidor.empresa.cnpj, cardData.instituicaoLiquidada.nome, cardData.instituicaoLiquidada.dataLiquidacao, cardData.instituicaoLiquidada.isAguardandoDadosDoLiquidante, isSolicitar)
      return;
    }

    if(isCorrigirInformacoes){
      this.openEditar(cardData.investidor.empresa.cnpj, cardData.idPedido);
      return;
    }

    if(isAceitarTermo || isPedidoAndamento){
      this.openModalStatus(cardData.idPedido);
      return;
    }

    this.exibirMensagem(statusProcesso,tipoProcesso);
  }

  openEditar(cnpjEmpresa, idPedido) {
    this.router.navigate(["/spg/editar-credor", cnpjEmpresa, idPedido]);
  }

  showModal(dados) {
    let config = {
      scroll: true,
      ignoreBackdropClick: true,
      data: { idInvestidor: dados, garantiaOrdinaria: true },
    };

    this.modalRef = this.modalService.show(ModalEditarDadosComponent, config);
  }

  openModalStatus(cardData) {
    let config = {
      scroll: true,
      ignoreBackdropClick: true,
      data: { id: cardData },
    };

    this.modalRef = this.modalService.show(ModalStatusAssinaturaComponent, config);
  }

  exibirButton(status) {
    switch (status) {
      case 1: {
        return;
      }
      case 2: {
        return true;
      }
      case 3: {
        return true;
      }
      case 4: {
        return true;
      }
      case 5: {
        return true;
      }
      case 6: {
        return true;
      }
      case 7: {
        return true;
      }
      case 8: {
        return true;
      }
      case 9: {
        return true;
      }
      case 10: {
        return true;
      }
      case 11: {
        return true;
      }
      case 12: {
        return true;
      }
      case 15: {
        return true;
      }
      case 13: {
        return true;
      }
      case 16: {
        return true;
      }
      case 17: {
        return true;
      }
      case 20: {
        return true;
      }
      case 21: {
        return true;
      }
      case 24: {
        return true;
      }
      case 38: {
        return true;
      }

      default: {
        return true;
      }
    }

    return false;
  }

  customButtonStyle(garantia : PedidoGarantia) {
    const status = garantia.status?.statusProcesso?.codigo || 0;

    const classes = {
      1 : "btnCompletarSolicitacao",
      3 : "btnAcompanharProcesso",
      8 : "btnAcompanharProcesso",
      9 : "btnPagamentoProcessamento",
      10: "btnAssinarTermo",
      11: "btnPagamentoAprovado",
      15: "btnPagamentoAprovado",
      16: "btn-gray",
      20: "btn-gray",
      21: "btnPedidoIndisponivel",
      24: "btnCorrigirInformacoes",
      25: "btnAcompanharProcesso",
      38: "btnAcompanharProcesso"
    };

    return "btn " + (classes[status] || "");
  }

  atualizarCardsExibidos(valor: TiposVisualizacao) {
    this.visualizacaoSelecionada = valor;
    this.cardsExibidos = valor === TiposVisualizacao.INSTITUICAO_FINANCEIRA ? this.cardsPorIf : this.cardsPorEmpresa;
    this.filtrarCards();
  }

  filtrarCards() {
    const base = this.visualizacaoSelecionada === TiposVisualizacao.INSTITUICAO_FINANCEIRA ? this.cardsPorIf : this.cardsPorEmpresa;
    if (!this.termoPesquisa || this.termoPesquisa.trim() === '') {
      this.cardsExibidos = base;
    } else {
      const termo = this.termoPesquisa.toLowerCase().trim();
      this.cardsExibidos = base.filter(card => {
        const tituloMatch = card.titulo.toLowerCase().includes(termo);
        const subtituloMatch = card.subtitulo.toLowerCase().includes(termo);
        const agrupadosMatch = card.agrupados?.some(agrupado =>
          agrupado.titulo.toLowerCase().includes(termo) ||
          agrupado.subtitulo.toLowerCase().includes(termo) ||
          agrupado.descricao.toLowerCase().includes(termo)
        ) || false;
        return tituloMatch || subtituloMatch || agrupadosMatch;
      });
    }
    this.mostrarPesquisaVazia = this.cardsExibidos.length === 0;
  }

  onPesquisaChange() {
    this.filtrarCards();
  }

  limparPesquisa() {
    this.termoPesquisa = '';
    this.filtrarCards();
  }
}
